export const SCHEDULING_MODE = [{ id: "room", name: "By Room" }];

export const TYPE_ORDER = [
  { id: "particular", name: "Particular" },
  { id: "company", name: "Company" },
];

export const INGRESS_SERVICE_HEALTH = [
  { id: "01", name: "Demanda espontánea" },
  { id: "02", name: "Derivado de consulta externa" },
  { id: "03", name: "Derivado de urgencias" },
  { id: "04", name: "Derivado de hospitalización" },
  { id: "05", name: "Derivado de sala de cirugía" },
  { id: "06", name: "Derivado de sala de partos" },
  { id: "07", name: "Recién nacido en la institución" },
  { id: "08", name: "Recién nacido en otra institución" },
  { id: "09", name: "Derivado o referido de hospitalización domiciliaria" },
  { id: "10", name: "Derivado de atención domiciliaria" },
  { id: "11", name: "Derivado de telemedicina" },
  { id: "12", name: "Derivado de jornada de salud" },
  { id: "13", name: "Referido de otra institución" },
  { id: "14", name: "Contrarreferido de otra institución" },
];

export const TIMEZONE_OFFSET_HOURS = 5;
